export let pinnedGroupHeader = "c7MgDc";
export default {pinnedGroupHeader};